import moment from 'moment'
import {
  DATE_FILTER_FORMAT,
  RequiredDateFilterDefault,
} from '@components/integration-filters/components'
import { DataOption } from '../../components'

export const GoogleDV360DataOptions = [
  {
    type: 'advertisers',
    label: 'Advertisers',
  },
  {
    type: 'campaigns',
    label: 'Campaigns',
  },
  {
    type: 'insertion_orders',
    label: 'Insertion Orders',
  },
  {
    type: 'line_items',
    label: 'Line Items',
  },
  {
    type: 'creatives',
    label: 'Creatives',
  },
  {
    type: 'ad_groups',
    label: 'Ad Groups',
  },
  {
    type: 'ads',
    label: 'Ads',
  },
] as const satisfies DataOption[]

export const GOOGLE_DV360_DATA_TYPE_KEY = 'dv360_data_type'

const oneYearAgo = moment().subtract(1, 'years').format(DATE_FILTER_FORMAT)

export const GOOGLE_DV360_REQUIRED_FILTER_DEFAULTS = [
  {
    key: 'update_time_filter',
    operator: '>',
    value: oneYearAgo,
    display_name: oneYearAgo,
  },
] as const satisfies RequiredDateFilterDefault[]
